import { AfterViewInit, Component, computed, ElementRef, inject, input } from '@angular/core';
import { Milestone, PrizeUI } from '../../progress-line.model';
import { SharedModule } from '@app/shared/shared.module';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { Display, FontSizeRescalerService } from '@app/shared/services/font-rescaler.service';
import { GsapService } from '@app/shared/animations/gsap.service';

const ANIM_SELECTORS: string[] = ['.prize', 'slotcom-display', '.shine'];

@Component({
  selector: 'slotcom-casino-milestone',
  templateUrl: './milestone.component.html',
  styleUrls: ['./milestone.component.scss'],
  standalone: true,
  imports: [SharedModule, DisplayComponent],
})
export class MilestoneComponent implements AfterViewInit {
  readonly milestone = input<Milestone>();
  readonly prizeUI = input<PrizeUI>();

  private readonly fontSizeRescalerService = inject(FontSizeRescalerService);
  private readonly gsap = inject(GsapService);
  private readonly elRef = inject(ElementRef<HTMLElement>);

  private hasAnimated = false;

  readonly fontSize = computed(() =>
    this.fontSizeRescalerService.setFontSize(Display.CreditsWallet, Number(this.prizeUI()?.text))
  );

  ngAfterViewInit(): void {
    if (this.hasAnimated) return;
    this.hasAnimated = true;

    const host = this.elRef.nativeElement;
    const animElements = ANIM_SELECTORS.map((sel) => host.querySelector(sel)).filter(
      (el): el is HTMLElement => el instanceof HTMLElement
    );

    if (animElements.length) {
      this.gsap.sequence(animElements, {
        stagger: 0.08,
        duration: 0.5,
        ease: 'back.out(1.4)',
      });
    }
  }
}
